import {SubmissionError} from "redux-form";
import Cookies from "js-cookie";
import {fetch} from "../utils/dataAccess";
import {sessionStore} from "../utils/sessionStore";

export function error(error) {
    return {type: "LOGIN_ERROR", error};
}

export function loading(loading) {
    return {type: "LOGIN_LOADING", loading};
}

export function success(userData) {
    return {type: "LOGIN_SUCCESS", userData};
}

export function getSessionOrganizations() {
    return sessionStore.get('organizations');
}

export function putSessionOrganizations(session) {
    if (typeof session !== 'object') {
        console.warn('Trying to put session with a non object.');
        return;
    }

    sessionStore.set('organizations', session);
}

export function login(values) {
    return (dispatch) => {
        dispatch(loading(true));

        return fetch("/login_check", {method: "POST", body: JSON.stringify(values)})
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.putSessionOrganizations(data);

                dispatch(success(data));
                dispatch(loading(false));
            })
            .catch(e => {
                dispatch(loading(false));

                if (e instanceof SubmissionError) {
                    dispatch(error(e.errors._error));
                    throw e;
                }
                dispatch(error(e.message));
            });
    };
}

export function logout() {
    let protocol = window.location.protocol;
    let host = window.location.host;
    let parts = host.split(":");

    const authSubdomain = process.env.REACT_APP_CUSTOM_AUTH_SUBDOMAIN ?? "auth.";
    let url = authSubdomain + process.env.REACT_APP_HOST;

    // in-case we have a port number in the host url. (For dev environment)
    if (parts.length === 2) {
        url += ":" + parts[1]
    }

    sessionStore.remove('organizations');
    window.location = protocol + "//" + url + "/login";

    return (dispatch) => {
        fetch("/logout", {method: "POST"})
            .then(response => {
                dispatch('LOGOUT_SUCCESS');
                return response.json();
            })
            .catch(e => {
                if (e instanceof SubmissionError) {
                    dispatch(error(e.errors._error));
                    throw e;
                }

                dispatch(error(e.message));
            });
    };

}
